//
// Axis.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModel";
import "@sas-dvr/ltjs-commons/models/data/AxisDimension";
import "./BusinessItem";

var Axis = createModule("BIRD::Axis", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        businessItems: [1],
        type: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default Axis;
